import { render } from "./NestedView.vue?vue&type=template&id=4faa56c5"
const script = {}
script.render = render

export default script